import React from 'react'
import '../styles/layout/Services.css'
import { Container } from 'react-bootstrap';

const ServiceValue = () => {
  return (
    <section className="section our-values">
        <Container>
            <div className="our-values__grid">
                <div className="reveal">
                    <h2>Our Value Proposition</h2>
                    <span className="rule" />
                </div>
                <p className="reveal" data-delay="1">As a bank, entrusting your credit card management and operations to
                    <strong> 42 Card Solutions </strong>
                    not only provides you with a cost-effective and scalable credit card program but
                    also gives you access to futuristic technology with the latest digital and mobile
                    solutions and an enhanced user experience. Along with an experienced team of bankers,
                    42 Card Solutions offers you cutting edge technology that is robust, flexible and
                    would meet the rigorous compliance, regulatory, risk and fraud control
                    requirements of your organisation. Our services include –
                </p>
            </div>
        </Container>
    </section>
  )
}

export default ServiceValue
